import React from 'react';
import { AppIndex } from '../AppIndex';
import '../../../assets/css/app.css';
import '../../../assets/css/index.css';
import '../../i18n';

export const App = () => {
  return <AppIndex />;
};
